<template>
  <main id="operator">
    <el-autocomplete
      v-model.trim="ruleForm[keyName]"
      :fetch-suggestions="querySearch"
      :value-key="'val'"
      :debounce="0"
      autocomplete="off"
      clearable
      :placeholder="placeholder"
      @select="selectMain"
      @blur="blurMain"
      :class="className"
    >
    </el-autocomplete>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import { setTimeout } from 'timers'
import axios from '@didi/dajax'
export default {
  data() {
    return {
      options: [],
    }
  },
  computed: {
    ...mapState('vehicle', ['searchList', 'noOptions']),
  },
  methods: {
    querySearch(queryString, cb) {
      this.$store.dispatch(this.url, {
        ...this.params,
        key: queryString || '',
      })
      // clearTimeout(this.timeout)
      this.timeout = setInterval(() => {
        if (this.options.length) {
          clearInterval(this.timeout)
          cb(this.options)
        } else {
          cb([])
        }
      }, 1000)
    },
    selectMain(val) {
      this.callback(val)
      this.options = []
    },
    blurMain(val) {
      this.blurCallBack(val)
    },
  },
  watch: {
    searchList: function(val) {
      this.options = val
    },
    noOptions: function(val) {
      if (val) {
        this.options = []
      }
    },
  },
  props: {
    ruleForm: {
      type: Object,
    },
    keyName: {
      type: String,
    },
    params: {
      type: Object,
      default() {
        return {}
      },
    },
    callback: {
      type: Function,
      default() {
        return function() {}
      },
    },
    blurCallBack: {
      type: Function,
      default() {
        return function() {}
      },
    },
    className: {
      type: String,
      default() {
        return 'inline-input'
      },
    },
    url: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '请输入',
    },
  },
}
</script>

<style></style>
